export default __webpack_public_path__ + "static/media/Ri of Four Trigrams.bd905883.png";